
import "bootstrap/dist/css/bootstrap.min.css";
import config from "../../envconfig";
console.log("config",config)
const AboutUs = () => {


  return (
    <> 
       
    <div className='main_container_about'>
      <div>
        <div className="inner-container">
          <h3 style={{ color: "#295a80", fontSize: "30px", fontWeight: "bold" }}>
            About Us
          </h3>
          <h3  style={{ color: "#465a64", fontSize: "23px", fontWeight: "bold" }}>
            SmartTrackerPlus
          </h3>
          <h3  style={{ color: "#465a64", fontSize: "23px", fontWeight: "bold" }}>
           Version : {config.APP_VERSION}
          </h3>
          {/* <h3 style={{ color: "#465a64", fontSize: "20px", fontWeight: "bold" }}>
          Version : {config.APP_VERSION}
          </h3> */}
          <h3  style={{ color: "#465a64", fontSize: "20px", fontWeight: "bold" }}>
            Shubham Automation Pvt. Ltd.
          </h3>
          <p  style={{ color: "#465a64", fontSize: "18px", fontWeight: "500" }}>
            Plot No. 84/3/A, Phase-1, Nr. Span Industrial Complex, Road No. F, G.I.D.C., Vatva, Ahmedabad-382445 (Gujarat, INDIA)
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default AboutUs;

